import { useMemo } from 'react';
import i18next from 'i18next';
import SeatsMap from './SeatsMap';
import AllianceList from './AllianceList';
import VotingSummary from './VotingSummary';
import StateVotingTable from './StateVotingTable';
import MalaysiaMap from '../MalaysiaMap/MalaysiaMap';
import { buildCoalitionLookup, OTHERS_COLOR } from '../../utils/coalitionLookup';

// Historical state names (Malay/official) → MalaysiaMap's English shape keys.
const STATE_NAME_FIX = {
  'Pulau Pinang': 'Penang',
  Melaka: 'Malacca',
  'W.P. Kuala Lumpur': 'Kuala Lumpur',
  'W.P. Putrajaya': 'Putrajaya',
  'W.P. Labuan': 'Labuan',
};

const YearSlide = ({ election }) => {
  const { stateData, groupsById } = useMemo(() => {
    const { partyToCoalition, colorOf } = buildCoalitionLookup(election);
    const sd = {};
    (election.states || []).forEach((s) => {
      const allocation = {};
      Object.entries(s.breakdown || {}).forEach(([party, seats]) => {
        const coalition = partyToCoalition[party] || 'Others';
        allocation[coalition] = (allocation[coalition] || 0) + seats;
      });
      const key = STATE_NAME_FIX[s.name] || s.name;
      sd[key] = { totalSeats: s.seats, allocation };
    });
    const gb = {};
    Object.keys(election.coalitions || {}).forEach((name) => {
      gb[name] = { name, color: colorOf(name) };
    });
    gb.Others = { name: 'Others', color: OTHERS_COLOR };
    return { stateData: sd, groupsById: gb };
  }, [election]);

  return (
    <div className="year-slide">
      <header className="year-slide__header">
        <h2 className="year-slide__year">{election.year}</h2>
        <div className="year-slide__meta">
          <div>{election.parliament}</div>
          <div>{i18next.t('总议席')}: {election.totalSeats}</div>
          <div>{i18next.t('执政')}: <strong>{election.winningCoalition}</strong></div>
        </div>
      </header>

      {election.notes && (
        <section className="year-slide__notes">
          <h3>{i18next.t('历史背景')}</h3>
          <p>{election.notes}</p>
        </section>
      )}

      <section className="year-slide__section">
        <h3>{i18next.t('投票统计')}</h3>
        <VotingSummary voting={election.voting} />
      </section>

      <section className="year-slide__section">
        <h3>{i18next.t('各州战况') + ' ' + election.year}</h3>
        <MalaysiaMap stateData={stateData} groupsById={groupsById} />
      </section>

      <section className="year-slide__section">
        <h3>{i18next.t('国会议席分布')}</h3>
        <SeatsMap election={election} />
      </section>

      <section className="year-slide__section">
        <h3>{i18next.t('联盟与政党')}</h3>
        <AllianceList election={election} />
      </section>

      <section className="year-slide__section">
        <h3>{i18next.t('各州投票情况')}</h3>
        <StateVotingTable states={election.states} />
      </section>
    </div>
  );
};

export default YearSlide;
